/**
 * Added exipryTimestamp restriction to FB query based on todays date
 * Adds open and close timestamp restriction based on toggle status (filters.le_openTimestamp)
 * @author Ryan McAvoy
 * @date 2023-11-30
 * @param {object} filters
 * @returns {object} params
 */

const composeRuntimePeer = (filters = {}) => {
  let params = {};
  const today = new Date();

  // add filter range to FB query
  params['le_openTimestamp'] = params['ge_closeTimestamp'] = '';
  if (filters?.le_openTimestamp?.toString() === 'true') {
    params['le_openTimestamp'] = params['ge_closeTimestamp'] =
      today.getFullYear().toString() + (today.getMonth() + 1).toString().padStart(2, '0') + today.getDate().toString().padStart(2, '0');
  }

  // restrict by expiry date
  // params['ge_expiryTimestamp'] = '';
  // if (filters?.ge_expiryTimestamp?.toString() === 'true' || !filters?.ge_expiryTimestamp)
  //  params['ge_expiryTimestamp'] = today.getFullYear().toString() + (today.getMonth() + 1).toString() + today.getDate().toString();

  //console.log('params', params);

  return params;
};

export default composeRuntimePeer;
